// extracted by mini-css-extract-plugin
module.exports = {"inventory-input-container":"ServiceInputModal_inventory-input-container__HEDbG","react-select-container":"ServiceInputModal_react-select-container__2zcTX"};